import styled from 'styled-components';

const StyledBadge = styled.div`
  display: inline-block;
  padding: 1px 4px;
  background: transparent;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  color: ${({ theme }) => theme.COLORS.BASE};
  border: 2px solid ${({ theme }) => theme.COLORS.BASE};
  border-radius: 6px;
`;

export default StyledBadge;
